/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React, { ReactElement } from "react";

import { DetailsList, DetailsListLayoutMode, IColumn, SelectionMode } from "@fluentui/react";

import { detailListStyles } from "Components/Common/SharedListStyles.styles";

import { IRoleGuideListProps } from "./IRoleGuideListProps";

/**
 * Role Guide component.
 * @param {IRoleGuideListProps} props the component props.
 * @returns {ReactElement} the component element.
 */
export const RoleGuideList = (props: IRoleGuideListProps): ReactElement => {
  const { roles, items } = props;

  const columns: IColumn[] = [
    {
      key: "permission",
      fieldName: "permission",
      name: "Role",
      minWidth: 200,
      maxWidth: 250,
      isResizable: true,
      isSorted: false,
    },
    ...roles.map((role) => {
      return {
        key: role.id,
        fieldName: role.id,
        name: role.name,
        minWidth: 140,
        maxWidth: 160,
        isResizable: false,
        isSorted: false,
      };
    }),
  ];

  return (
    <>
      <DetailsList
        items={items}
        columns={columns}
        selectionMode={SelectionMode.none}
        setKey="none"
        layoutMode={DetailsListLayoutMode.fixedColumns}
        isHeaderVisible={true}
        enterModalSelectionOnTouch={true}
        styles={detailListStyles}
      />
    </>
  );
};
